const autoNgTemplateLoaderTemplate1 = require('./settingsEdgeCompute.html');

import angular from 'angular';
import controller from './settingsEdgeComputeController';

angular.module('portainer.app').component('settingsEdgeComputeView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
